import { api_login_url } from "./authApi";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { parser_login } from "./authParser";
import { authenticate, isAuth } from "../../helpers/cookies";
import { update_profile } from "../profile/profileSlice";

export const login = createAsyncThunk(
  "login",
  async (payload) => {
    try {
      const { username, password, company_domain } = payload;
      let formData = new FormData();
      formData.append('username', username);
      formData.append('password', password);
      formData.append('company_domain', company_domain);
      const response = await api_login_url(formData);
      const data = parser_login(response);
      return { data };
    } catch (error) {
      throw new Error(error);
    }
  }
);

const initialState = {
  login_is_loading: false,
  show_password: false,
  currentUser: isAuth() || null,
};

export const loginSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setShowPassword: (state, action) => {
      state.show_password = action.payload;
    },
    setResetState: (state, action) => {
      state.show_password = false;
      state.login_is_loading = false;
    },
    setCurrentUser: (state, action) => {
      state.currentUser = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(login.pending, (state) => {
      state.login_is_loading = true;
    })
    builder.addCase(login.fulfilled, (state, action) => {
      authenticate(action.payload.data, () => window.location.replace('/'));
      state.login_is_loading = false;
      // After authenticate, isAuth() should allow decoding the new token
      // provided the cookie was set synchronously/quickly enough.
      // Better to trust the payload if it matches the structure, but payload.data is the auth response (token).
      // We can decode it or rely on isAuth. 
      // For now, let's defer reading isAuth until next render or rely on reload for login (standard).
    })
    builder.addCase(login.rejected, (state) => {
      state.login_is_loading = false;
    })

    // Listen for profile updates
    builder.addCase(update_profile.fulfilled, (state, action) => {
      const updatedData = action.payload?.data;
      // Basic validation to ensure we have a valid object and not an error
      if (updatedData && !updatedData.detail && !updatedData.type && !Array.isArray(updatedData)) {
        state.currentUser = { ...state.currentUser, ...updatedData };
      }
    });
  },
});

// Action creators are generated for each case reducer function
export const {
  setShowPassword,
  setResetState,
  setCurrentUser
} = loginSlice.actions;
export default loginSlice.reducer;